import { atom } from "jotai";

import { currentBookingAtom } from "../../stores";

export const getMemberBookingRoundsAtom = atom((get) => {
  const booking = get(currentBookingAtom);
  return (
    booking?.rounds.filter((round) => round.player.clientType === "member") ??
    []
  );
});
